// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_G0F","cls2":"TransactionalPricingModal-cls2_hMO TransactionalPricingModal-cls1_G0F"};